import {useEffect, useState,useContext} from "react";
import {useHistory} from "react-router-dom";
import SearchIcon from "@material-ui/icons/Search";
import {makeStyles} from "@material-ui/core/styles";
import { Box, Button, Card, CardContent, Grid,
    IconButton, LinearProgress, Paper, Tooltip,
    Typography, TextField } from "@material-ui/core";
import TablaProspecto from "./TablaProspecto";
import Autocomplete from "@material-ui/lab/Autocomplete";
import ModalNvoPerfilImg from '../nvoPerfil/ModalNvoPerfImg';
import Relojes from "./Relojes";
import axios from "axios";
import qs from "qs";
import {GeneralesContext} from '../context/GeneralesContext'
import { AuthContext } from "../context/AuthContext";
import {ErrorGeneral, llamaApiCargaToken,llamadaApiToken} from "../funciones/ClienteAxios";
import Galeria from "./Galeria";
import {AddCircleOutlined} from "@material-ui/icons";
import ModalNvoProspecto from "./ModalNvoProspecto";
import ModalAgregarEvidencia from "./ModalAgregarEvidencia";
import { authUser } from '../funciones/AuthUser'
const useStyles = makeStyles((theme) => ({}));

const arrBase={
    "Id": 0, "MunId": 0, "MunNom": "TODOS",
    "MunNum": 0, "UsrId": 0, "UsrNom": "",
    "UsrTel": "0","UsrUsr":""
  }

const Prospecto = () => {
    const classes = useStyles();
    const usu = localStorage.getItem('UsuarioNom');                
    const usuID = localStorage.getItem('UsuId') ?  parseInt(localStorage.getItem('UsuId')) : null;   
    const nvl= localStorage.getItem('Tipo');    
    const auxDispV = localStorage.getItem("Dispvo") && localStorage.getItem("Dispvo").length >= 12 ? localStorage.getItem("Dispvo") : "451224452121"; 
    const usuTitu = localStorage.getItem("usuTitu")?parseInt(localStorage.getItem("usuTitu")) :0   
    let history = useHistory();
    const source = axios.CancelToken.source();
    const {generales,guardarGenerales}=useContext(GeneralesContext); 
    const {usuario,guardarUsuario}=useContext(AuthContext);
    const [fechasSeleccionadas, setFechasSeleccionadas] = useState({
        inicio: new Date(), final: new Date(), });

    const [selectedID, setSelectedID] = useState(null);    
    const [prospecto, setProspecto] = useState([]);
    const [galeria, setGaleria] = useState([]);
    const [latitud, setLatitud] = useState(0);
    const [longitud, setLongitud] = useState(0);
    const [cargando, setCargando] = useState(false);
    const [abrirModalMapa, setAbrirModalMapa] = useState(false);
    const [actualizar, setActualizar] = useState(false);
    const [abrirModalAgregar, setAbrirModalAgregar] = useState(false);
    const [mensaje, setMensaje] = useState("");
    const [buscar, setBuscar] = useState(true);
    const [checked, setChecked] = useState(false);
    const [abrirModal, setAbrirModal] = useState(false);
    const [update, setUpdate] = useState(false);
    const [listEncargado,setListEncargado]=useState([])
    const [cargaList,setCargaList]=useState([])
    const [encargado,setEncargado]=useState([])
    const [listPlantilla,setListPlantilla]=useState([])
    const[nombre, setNombre]=useState("")
    const [modalNvoImg, setModalNvoImg] = useState(false);
    const[nvoRegis,setNvoRegis]= useState([]);
    useEffect(() => {
        
        const veriSesion =  () => {            
            let auxValidacion=authUser()
            if(!auxValidacion ||(usu===undefined||usu===''||usu===null)||(nvl===undefined||nvl===''||nvl===null)
                ||(usuID===undefined||usuID===''||usuID===null) )
            {   guardarUsuario([])				
                guardarGenerales([])    
                localStorage.clear();            	             
                history.push("/")	                	
            }
            else
            {   
                if (usuario.length==0) 
                {
                    guardarUsuario({Nombre:usu,nivel:nvl});                                         
                    
                }                                                       
                guardarGenerales({...generales,Titulo:'Militante'})  
                if ("geolocation" in navigator) 
                {   navigator.geolocation.getCurrentPosition(function (position) {
                        setLatitud(position.coords.latitude);
                        setLongitud(position.coords.longitude);
                    });
                } 
                else 
                {   setLatitud(0);
                    setLongitud(0);
                }                                                     
                
                if(usuTitu===1){
                    llenalistEncarga()
                }
                llenalistPlantilla()
            }   
        }

        veriSesion()
    }, []);


    useEffect(() => {
        setGaleria([]);
        if (prospecto !== null &&prospecto.length!==0 ) 
        {
            let arr=[]
            //arr.push({src:prospecto.Img1Mini,Descr:"lado 1" })
            //arr.push({src:prospecto.Img2Mini,Descr:"lado 2" })
            const consultarImagenes = () => {
                const data = qs.stringify({
                    Llave: prospecto.Id,
                    Usuario: usuID,
                    idDispositivo:auxDispV,
                });
                const url = "prospecto-file-list";
    
                function respuesta(aux) {
                    if (aux[0].Dir===""&& (aux[0].Arch1===""||aux[0].Arch2===""||aux[0].Arch3==="")) 
                    {
                        setGaleria([]);                             
                        setMensaje("Sin fotografías.");
                    } 
                    else 
                    {   arr.push({srcMini:aux[0].Dir+aux[0].Mini1
                        ,Descr:"lado 1",usrNom:aux[0].UsrNom,FReg:aux[0].FReg, 
                        archivo:aux[0].Dir+aux[0].Arch1
                        })
                        arr.push({srcMini:aux[0].Dir+aux[0].Mini2
                            ,Descr:"lado 2",usrNom:aux[0].UsrNom,FReg:aux[0].FReg, 
                            archivo:aux[0].Dir+aux[0].Arch2
                        })
                        arr.push({srcMini: aux[0].Size3 !==0 ? (aux[0].Dir + aux[0].Mini3) : "0"
                            ,Descr:"Selfie",usrNom:aux[0].UsrNom,FReg:aux[0].FReg, 
                            archivo:aux[0].Dir+aux[0].Arch3
                        })
                        setGaleria(arr);
                    }
                }
    
                llamaApiCargaToken(data, url, respuesta, ErrorGeneral, setCargando, history, source);
            }; 
            consultarImagenes()                                                 
        }
    }, [selectedID,update]);

    const llenalistEncarga = () => {
        const data = qs.stringify({        
            Usuario: usuID,
            idDispositivo: auxDispV,
        });
        const url = "coordinador-municipal-encargado-list";
    
        function respuesta(aux) {
            if (aux[0].Id!==-1 ) 
            {
                const nvoList=[arrBase, ...aux ]
                setListEncargado(nvoList)
            } 
            else 
            {   setListEncargado([])
            }
        }
    
        llamaApiCargaToken(data, url, respuesta, ErrorGeneral, setCargaList, history, source);
    }; 

    const llenalistPlantilla = () => {
        const data = qs.stringify({        
            usuario: usuID,
            dominio:process.env.REACT_APP_Dominio,
            idDispositivo:auxDispV,
        });
        const url = "plantilla-base-dominio";
    
        function respuesta(aux) {
            if (aux[0].Id != -1) 
            {   setListPlantilla(aux)           
            }
        }
    
        llamadaApiToken(data, url, respuesta, ErrorGeneral,  history, source);
    }; 

    const buscarDatos = () => {
        setBuscar(!buscar)
    }

    const modalAgregarEvidencia = abrirModal ? <ModalAgregarEvidencia abrirModal={abrirModal}
                                                setAbrirModal={setAbrirModal} prospecto={prospecto}
                                                selectedID={selectedID} idusu={usuID}  setUpdate={setUpdate}
                                            /> : null

    const modAgregarProspecto = abrirModalAgregar ? <ModalNvoProspecto abrirModal={abrirModalAgregar}
                                                        setAbrirModal={setAbrirModalAgregar}
                                                        idusu={usuID} history={history} buscarDatos={buscarDatos}
                                                        source={source} latitud={latitud}
                                                        longitud={longitud} 
                                                        setModalNvoImg={setModalNvoImg} setNvoRegis={setNvoRegis}
                                                    /> : null
    const modNvoImg =modalNvoImg  && listPlantilla.length!== 0  ? 
                    <ModalNvoPerfilImg modalAbierto={modalNvoImg} setModalAbierto={setModalNvoImg} 
                        titulo= {nvoRegis.Nom ? "Promovido "+nvoRegis.Nom:"Promovido"}  auxPerfImg={listPlantilla}
                        nvoRegisPerfil={nvoRegis} actualizar={actualizar} setActualizar={setActualizar}
                    />:null                                                             

    const agregarDatos = () => {
        setAbrirModalAgregar(true)
    }

    const listarGaleria =
        galeria.length !== 0 ? (
            <Galeria
                galeria={galeria}
            />
        ) : (
            <Paper className={classes.root}>
                <Typography variant={"h5"}>{mensaje}</Typography>
            </Paper>
        );

    const handleChange = () => {
        setChecked(!checked)
    };

    const handleAbrir = () => {
        setAbrirModal(true)
    }

    const guardarMuni=(e)=>{
        //console.log(e);
        if (e!== null && e!== undefined) 
        { setEncargado(e)            
        }
        else
        { setEncargado([])     
        }
     
    }

    const onChange = e => {
        setNombre( e.target.value)
    }
    const principal = () => {
        return (
            <Grid container spacing={1}>
                {modAgregarProspecto}
                {modNvoImg}
                <Grid item xs={12}>
                    <Card>
                        <CardContent style={{padding:0.4+'rem'}} >
                            <Grid container spacing={1} alignItems={'center'}>
                                <Grid item>
                                    <Tooltip title={'Buscar'}>
                                        <IconButton
                                            color="primary"
                                            aria-label="Buscar"
                                            onClick={buscarDatos}
                                        >
                                            <SearchIcon/>
                                        </IconButton>
                                    </Tooltip>
                                </Grid>
                                <Grid item>
                                    <Relojes
                                        fechasSeleccionadas={fechasSeleccionadas}
                                        setFechasSeleccionadas={setFechasSeleccionadas}
                                    />
                                </Grid>                            
                                 <Grid item>
                                    <Tooltip title={'Agregar Prospecto'}>
                                        <IconButton
                                            color="primary"
                                            aria-label="Agregar Prospecto"
                                            onClick={agregarDatos}
                                        >
                                            <AddCircleOutlined/>
                                        </IconButton>
                                    </Tooltip>
                                </Grid>
                                <Grid item>
                                    { usuTitu ===1 && listEncargado.length!==0 ?
                                        <Autocomplete
                                        id="encargados-autocomplete-01" size='small'
                                        onChange={(e,option)=>guardarMuni(option)}
                                        options={listEncargado}
                                        getOptionLabel={(option) => `${option.MunNom} - ${option.UsrNom} ${option.UsrUsr!==""?"("+option.UsrUsr+")":""}`}
                                        style={{ width: 40+'rem' }}
                                        noOptionsText={"Sin coincidencias"}
                                        renderInput={(params) => (
                                            <TextField {...params} 
                                            label="Encargados" variant="outlined" />
                                        )}
                                        />
                                    :<LinearProgress/>}
                                </Grid>
                                {usuID === 1 ?
                                <Grid item>
                                    <TextField id="nombre-txt" name="nombre" label="Nombre" fullWidth size="small"
                                        value={nombre} onChange={onChange} variant="outlined"/>  
                                </Grid>
                                :null }
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={8}>
                    <TablaProspecto
                        history={history} setProspecto={setProspecto}
                        fechasSeleccionadas={fechasSeleccionadas}
                        selectedID={selectedID} setSelectedID={setSelectedID}
                        source={source} idusu={usuID} buscar={buscar}
                        checked={checked} abrirModal={abrirModalMapa}
                        setAbrirModal={setAbrirModalMapa} buscarDatos={buscarDatos}
                        encargado={encargado} nombre={nombre}
                    />
                </Grid>
                <Grid item xs={4}>
                    {modalAgregarEvidencia}
                    {selectedID !== null ? <Grid container>
                        <Grid item xs={12} style={{paddingBottom: 10}}>
                            <Button
                                variant="contained" color="primary"
                                startIcon={<AddCircleOutlined/>}
                                onClick={handleAbrir}
                            >
                                Subir Fotos
                            </Button>
                        </Grid>
                    </Grid> : null}
                    {cargando ? (
                        <Box pl={1} pt={5}>
                            <LinearProgress/>
                        </Box>
                    ) : (
                        listarGaleria
                    )}
                </Grid>
            </Grid>
        );
    };

    return <div>{principal()}</div>;
};

export default Prospecto;
